// App
export const TOGGLE_LEFT_SIDENAV = 'TOGGLE_LEFT_SIDENAV';
export const TOGGLE_RIGHT_SIDENAV = 'TOGGLE_RIGHT_SIDENAV';

// Auth
export const LOGIN_USER_START = 'LOGIN_USER_START';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const LOGIN_USER_INTERNAL_ERROR = 'LOGIN_USER_INTERNAL_ERROR';
export const LOGIN_USER_NOT_REGISTERED = 'LOGIN_USER_NOT_REGISTERED';
export const LOGIN_USER_UNSUBSCRIBED = 'LOGIN_USER_UNSUBSCRIBED';
export const REGISTER_USER_START = 'REGISTER_USER_START';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const UNAUTHORIZED_ACCESS = 'UNAUTHORIZED_ACCESS';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const FORGOT_PASSWORD_RESET = 'FORGOT_PASSWORD_RESET';
export const GET_FORGOT_PASSWORD_SUCCESS = 'GET_FORGOT_PASSWORD_SUCCESS';
export const GET_FORGOT_PASSWORD_ERROR = 'GET_FORGOT_PASSWORD_ERROR';
export const POST_RESET_PASSWORD_START = 'POST_RESET_PASSWORD_START';
export const POST_RESET_PASSWORD_SUCCESS = 'POST_RESET_PASSWORD_SUCCESS';
export const POST_RESET_PASSWORD_ERROR = 'POST_RESET_PASSWORD_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_START = 'LOGOUT_START';
export const GET_USER_START = 'GET_USER_START';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';
export const GET_STRIPE_USER_START = 'GET_STRIPE_USER_START';
export const GET_STRIPE_USER_SUCCESS = 'GET_STRIPE_USER_SUCCESS';
export const GET_STRIPE_USER_FAIL = 'GET_STRIPE_USER_FAIL';
export const VERSION_MISMATCH = 'VERSION_MISMATCH';
export const VERSION_MISMATCH_FALSE = 'VERSION_MISMATCH_FALSE';
export const VALIDATE_CS_USER_START = 'VALIDATE_CS_USER_START';
export const VALIDATE_CS_USER_SUCCESS = 'VALIDATE_CS_USER_SUCCESS';
export const VALIDATE_CS_USER_FAIL = 'VALIDATE_CS_USER_FAIL';

// Domain
export const GET_DOMAINS_START = 'GET_DOMAINS_START';
export const GET_DOMAINS_SUCCESS = 'GET_DOMAINS_SUCCESS';
export const GET_DOMAINS_ERROR = 'GET_DOMAINS_ERROR';
export const GET_PRICING_PLANS_START = 'GET_PRICING_PLANS_START';
export const GET_PRICING_PLANS_SUCCESS = 'GET_PRICING_PLANS_SUCCESS';
export const GET_PRICING_PLANS_ERROR = 'GET_PRICING_PLANS_ERROR';

// Business
export const GET_BUSINESS_START = 'GET_BUSINESS_START';
export const GET_BUSINESS_SUCCESS = 'GET_BUSINESS_SUCCESS';
export const GET_BUSINESS_ID_SUCCESS = 'GET_BUSINESS_ID_SUCCESS';
export const GET_BUSINESS_FAIL = 'GET_BUSINESS_FAIL';
export const GET_BUSINESS_STATUS_START = 'GET_BUSINESS_STATUS_START';
export const GET_BUSINESS_STATUS_SUCCESS = 'GET_BUSINESS_STATUS_SUCCESS';
export const GET_BUSINESS_STATUS_FAIL = 'GET_BUSINESS_STATUS_FAIL';
export const GET_PHONE_LIST_SUCCESS = 'GET_PHONE_LIST_SUCCESS';
export const GET_PHONE_LIST_FAIL = 'GET_PHONE_LIST_FAIL';
export const ADD_PHONE_NUMBER_START = 'ADD_PHONE_NUMBER_START';
export const ADD_PHONE_NUMBER_SUCCESS = 'ADD_PHONE_NUMBER_SUCCESS';
export const ADD_PHONE_NUMBER_FAIL = 'ADD_PHONE_NUMBER_FAIL';
export const REMOVE_PHONE_NUMBER_START = 'REMOVE_PHONE_NUMBER_START';
export const REMOVE_PHONE_NUMBER_SUCCESS = 'REMOVE_PHONE_NUMBER_SUCCESS';
export const REMOVE_PHONE_NUMBER_FAIL = 'REMOVE_PHONE_NUMBER_FAIL';
export const GET_BUSINESS_DETAILS_START = 'GET_BUSINESS_DETAILS_START';
export const GET_BUSINESS_DETAILS_SUCCESS = 'GET_BUSINESS_DETAILS_SUCCESS';
export const GET_BUSINESS_DETAILS_FAIL = 'GET_BUSINESS_DETAILS_FAIL';
export const GET_BUSINESS_LOCATIONS_SUCCESS = 'GET_BUSINESS_LOCATIONS_SUCCESS';
export const GET_BUSINESS_LOCATIONS_START = 'GET_BUSINESS_LOCATIONS_START';
export const GET_BUSINESS_LOCATIONS_FAIL = 'GET_BUSINESS_LOCATIONS_FAIL';
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION';

// Carrier
export const GET_TEXT_NUMBER_SUCCESS = 'GET_TEXT_NUMBER_SUCCESS';
export const GET_TEXT_NUMBER_FAIL = 'GET_TEXT_NUMBER_FAIL';
export const TEXT_CALLFORWARD_START = 'TEXT_CALLFORWARD_START';
export const TEXT_CALLFORWARD_SUCCESS = 'TEXT_CALLFORWARD_SUCCESS';
export const TEXT_CALLFORWARD_FAIL = 'TEXT_CALLFORWARD_FAIL';

// Booking Software
export const GET_SOFTWARES_START = 'GET_SOFTWARES_START';
export const GET_SOFTWARES_SUCCESS = 'GET_SOFTWARES_SUCCESS';
export const GET_SOFTWARES_FAIL = 'GET_SOFTWARES_FAIL';
export const RESET_SELECTED_SOFTWARE = 'RESET_SELECTED_SOFTWARE';
export const SET_SOFTWARES_RESET = 'SET_SOFTWARES_RESET';
export const SET_SOFTWARES_SUCCESS = 'SET_SOFTWARES_SUCCESS';
export const SET_SOFTWARES_FAIL = 'SET_SOFTWARES_FAIL';
export const BOOKING_SOFTWARE_SELECTED = 'BOOKING_SOFTWARE_SELECTED';
export const RESET_BOOKING_SOFTWARE_SELECTED = 'RESET_BOOKING_SOFTWARE_SELECTED';
export const GET_STUDIO_ID_SUCCESS = 'GET_STUDIO_ID_SUCCESS';
export const GET_STUDIO_ID_FAIL = 'GET_STUDIO_ID_FAIL';
export const GET_SOFTWARE_ACTIVATION_START = 'GET_SOFTWARE_ACTIVATION_START';
export const GET_SOFTWARE_ACTIVATION_SUCCESS = 'GET_SOFTWARE_ACTIVATION_SUCCESS';
export const GET_SOFTWARE_ACTIVATION_FAIL = 'GET_SOFTWARE_ACTIVATION_FAIL';
export const RESET_BOOKING_SOFTWARE_SETUP = 'RESET_BOOKING_SOFTWARE_SETUP';
export const COMPLETE_BOOKING_SOFTWARE_SETUP = 'COMPLETE_BOOKING_SOFTWARE_SETUP';
export const SEND_NOTIFICATION_START = 'SEND_NOTIFICATION_START';
export const SEND_NOTIFICATION_SUCCESS = 'SEND_NOTIFICATION_SUCCESS';
export const SEND_NOTIFICATION_FAIL = 'SEND_NOTIFICATION_FAIL';
export const VERIFY_BOOKING_SOFTWARE_START = 'VERIFY_BOOKING_SOFTWARE_START';
export const VERIFY_BOOKING_SOFTWARE_SUCCESS = 'VERIFY_BOOKING_SOFTWARE_SUCCESS';
export const VERIFY_BOOKING_SOFTWARE_FAIL = 'VERIFY_BOOKING_SOFTWARE_FAIL';
export const REQUEST_BOOKING_SOFTWARE_START = 'REQUEST_BOOKING_SOFTWARE_START';
export const REQUEST_BOOKING_SOFTWARE_SUCCESS = 'REQUEST_BOOKING_SOFTWARE_SUCCESS';
export const REQUEST_BOOKING_SOFTWARE_FAIL = 'REQUEST_BOOKING_SOFTWARE_FAIL';
export const APPROVE_BOOKING_SOFTWARE_ACCESS_START = 'APPROVE_BOOKING_SOFTWARE_ACCESS_START';
export const APPROVE_BOOKING_SOFTWARE_ACCESS_SUCCESS = 'APPROVE_BOOKING_SOFTWARE_ACCESS_SUCCESS';
export const APPROVE_BOOKING_SOFTWARE_ACCESS_FAIL = 'APPROVE_BOOKING_SOFTWARE_ACCESS_FAIL';
export const DECLINE_BOOKING_SOFTWARE_ACCESS_START = 'DECLINE_BOOKING_SOFTWARE_ACCESS_START';
export const DECLINE_BOOKING_SOFTWARE_ACCESS_SUCCESS = 'DECLINE_BOOKING_SOFTWARE_ACCESS_SUCCESS';
export const DECLINE_BOOKING_SOFTWARE_ACCESS_FAIL = 'DECLINE_BOOKING_SOFTWARE_ACCESS_FAIL';
export const GET_BOOKING_SOFTWARE_REQUEST_START = 'GET_BOOKING_SOFTWARE_REQUEST_START';
export const GET_BOOKING_SOFTWARE_REQUEST_SUCCESS = 'GET_BOOKING_SOFTWARE_REQUEST_SUCCESS';
export const GET_BOOKING_SOFTWARE_REQUEST_FAIL = 'GET_BOOKING_SOFTWARE_REQUEST_FAIL';
export const POST_BOOKER_ACCOUNT_INFO_START = 'POST_BOOKER_ACCOUNT_INFO_START';
export const POST_BOOKER_ACCOUNT_INFO_SUCCESS = 'POST_BOOKER_ACCOUNT_INFO_SUCCESS';
export const POST_BOOKER_ACCOUNT_INFO_FAIL = 'POST_BOOKER_ACCOUNT_INFO_FAIL';
export const BOOKER_EMAIL_SEND_SUCCESS = 'BOOKER_EMAIL_SEND_SUCCESS';
export const BOOKER_EMAIL_SEND_RESET = 'BOOKER_EMAIL_SEND_RESET';
export const POST_ZENOTI_ACCOUNT_INFO_START = 'POST_ZENOTI_ACCOUNT_INFO_START';
export const POST_ZENOTI_ACCOUNT_INFO_SUCCESS = 'POST_ZENOTI_ACCOUNT_INFO_SUCCESS';
export const POST_ZENOTI_ACCOUNT_INFO_FAIL = 'POST_ZENOTI_ACCOUNT_INFO_FAIL';
export const POST_ZENOTI_AUTHORIZATION_SUCCESS = 'POST_ZENOTI_AUTHORIZATION_SUCCESS';
export const POST_ZENOTI_AUTHORIZATION_FAIL = 'POST_ZENOTI_AUTHORIZATION_FAIL';
export const POST_ZENOTI_AUTHORIZATION_START = 'POST_ZENOTI_AUTHORIZATION_START';
export const POST_ZENOTI_STAFF_LOGIN_SUCCESS = 'POST_ZENOTI_STAFF_LOGIN_SUCCESS';
export const POST_ZENOTI_STAFF_LOGIN_FAIL = 'POST_ZENOTI_STAFF_LOGIN_FAIL';
export const POST_ZENOTI_STAFF_LOGIN_START = 'POST_ZENOTI_STAFF_LOGIN_START';

export const POST_ZENOTI_CONFIGURE_SETUP = 'POST_ZENOTI_CONFIGURE_SETUP';
export const POST_ZENOTI_REFERRAL = 'POST_ZENOTI_REFERRAL';
export const STORE_ZENOTI_DATA = 'STORE_ZENOTI_DATA';

export const STORE_MEEVO_DATA = 'STORE_MEEVO_DATA';
export const AUTH_FLAG_CLEAR = 'AUTH_FLAG_CLEAR';

export const GET_BOOKING_SOFTWARE_LOCATIONS_START = 'GET_BOOKING_SOFTWARE_LOCATIONS_START';
export const GET_BOOKING_SOFTWARE_LOCATIONS_SUCCESS = 'GET_BOOKING_SOFTWARE_LOCATIONS_SUCCESS';
export const GET_BOOKING_SOFTWARE_LOCATIONS_FAIL = 'GET_BOOKING_SOFTWARE_LOCATIONS_FAIL';

// Greeting
export const GET_GREETING_SUCCESS = 'GET_GREETING_SUCCESS';
export const GET_GREETING_FAIL = 'GET_GREETING_FAIL';
export const SET_GREETING_SUCCESS = 'SET_GREETING_SUCCESS';
export const SET_GREETING_FAIL = 'SET_GREETING_FAIL';
export const RESET_GREETING_START = 'RESET_GREETING_START';
export const RESET_GREETING_SUCCESS = 'RESET_GREETING_SUCCESS';
export const RESET_GREETING_FAIL = 'RESET_GREETING_FAIL';

// Dashboard
export const GET_TASKS_STATUS_SUCCESS = 'GET_TASKS_STATUS_SUCCESS';
export const GET_TASKS_STATUS_FAIL = 'GET_TASKS_STATUS_FAIL';
export const GET_METRICS_START = 'GET_METRICS_START';
export const GET_METRICS_SUCCESS = 'GET_METRICS_SUCCESS';
export const GET_METRICS_FAIL = 'GET_METRICS_FAIL';
export const GET_SETUP_INFO_SUCCESS = 'GET_SETUP_INFO_SUCCESS';
export const GET_SETUP_INFO_FAIL = 'GET_SETUP_INFO_FAIL';
export const GET_REPORT_DATA_START = 'GET_REPORT_DATA_START';
export const GET_REPORT_DATA_SUCCESS = 'GET_REPORT_DATA_SUCCESS';
export const GET_REPORT_DATA_FAIL = 'GET_REPORT_DATA_FAIL';

//  Voicemails
export const GET_VOICEMAILS_START = 'GET_VOICEMAILS_START';
export const GET_VOICEMAILS_SUCCESS = 'GET_VOICEMAILS_SUCCESS';
export const GET_VOICEMAILS_FAIL = 'GET_VOICEMAILS_FAIL';
export const MARK_VOICEMAIL_START = 'MARK_VOICEMAIL_START';
export const MARK_VOICEMAIL_SUCCESS = 'MARK_VOICEMAIL_SUCCESS';
export const MARK_VOICEMAIL_FAIL = 'MARK_VOICEMAIL_FAIL';

//  Preferences
export const SET_PREFERENCES_START = 'SET_PREFERENCES_START';
export const SET_PREFERENCES_SUCCESS = 'SET_PREFERENCES_SUCCESS';
export const SET_PREFERENCES_FAIL = 'SET_PREFERENCES_FAIL';
export const GET_PREFERENCES_START = 'GET_PREFERENCES_START';
export const GET_PREFERENCES_SUCCESS = 'GET_PREFERENCES_SUCCESS';
export const GET_PREFERENCES_FAIL = 'GET_PREFERENCES_FAIL';
export const GET_FREE_PRICING_PLANS = 'GET_FREE_PRICING_PLANS';
export const GET_PREFERENCE_SCHEMA_START = 'GET_PREFERENCE_SCHEMA_START';
export const GET_PREFERENCE_SCHEMA_SUCCESS = 'GET_PREFERENCE_SCHEMA_SUCCESS';
export const GET_PREFERENCE_SCHEMA_FAIL = 'GET_PREFERENCE_SCHEMA_FAIL';
//  Billing
export const GET_INVOICES_START = 'GET_INVOICES_START';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAIL = 'GET_INVOICES_FAIL';
export const SEND_INVOICE_EMAIL_START = 'SEND_INVOICE_EMAIL_START';
export const SEND_INVOICE_EMAIL_SUCCESS = 'SEND_INVOICE_EMAIL_SUCCESS';
export const SEND_INVOICE_EMAIL_FAIL = 'SEND_INVOICE_EMAIL_FAIL';
export const ADD_CARD_START = 'ADD_CARD_START';
export const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS';
export const ADD_CARD_FAIL = 'ADD_CARD_FAIL';
export const GET_BILLING_PLAN_START = 'GET_BILLING_PLAN_START';
export const GET_BILLING_PLAN_SUCCESS = 'GET_BILLING_PLAN_SUCCESS';
export const GET_BILLING_PLAN_FAIL = 'GET_BILLING_PLAN_FAIL';
export const GET_CARDS_START = 'GET_CARDS_START';
export const GET_CARDS_SUCCESS = 'GET_CARDS_SUCCESS';
export const GET_CARDS_FAIL = 'GET_CARDS_FAIL';
export const GET_DEFAULT_CARD_START = 'GET_DEFAULT_CARD_START';
export const GET_DEFAULT_CARD_SUCCESS = 'GET_DEFAULT_CARD_SUCCESS';
export const GET_DEFAULT_CARD_FAIL = 'GET_DEFAULT_CARD_FAIL';
export const UNSUBSCRIBE_PLAN_START = 'UNSUBSCRIBE_PLAN_START';
export const UNSUBSCRIBE_PLAN_SUCCESS = 'UNSUBSCRIBE_PLAN_SUCCESS';
export const UNSUBSCRIBE_PLAN_FAIL = 'UNSUBSCRIBE_PLAN_FAIL';
export const GET_AVAILABLE_PLANS_START = 'GET_AVAILABLE_PLANS_START';
export const GET_AVAILABLE_PLANS_SUCCESS = 'GET_AVAILABLE_PLANS_SUCCESS';
export const GET_AVAILABLE_PLANS_FAIL = 'GET_AVAILABLE_PLANS_FAIL';
export const UPDATE_PLAN_START = 'UPDATE_PLAN_START';
export const UPDATE_PLAN_SUCCESS = 'UPDATE_PLAN_SUCCESS';
export const UPDATE_PLAN_FAIL = 'UPDATE_PLAN_FAIL';
export const GET_CLIENT_START = 'GET_CLIENT_START';
export const GET_CLIENT_SUCCESS = 'GET_CLIENT_SUCCESS';
export const GET_CLIENT_FAIL = 'GET_CLIENT_FAIL';

// Staff
export const GET_STAFF_START = 'GET_STAFF_START';
export const GET_STAFF_SUCCESS = 'GET_STAFF_SUCCESS';
export const GET_STAFF_FAIL = 'GET_STAFF_FAIL';
export const SET_STAFF_TYPES = 'SET_STAFF_TYPES';

// Services
export const GET_SERVICES_START = 'GET_SERVICES_START';
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS';
export const GET_SERVICES_FAIL = 'GET_SERVICES_FAIL';
export const SET_SERVICE_CATEGORIES = 'SET_SERVICE_CATEGORIES';

// Schedules
export const GET_SCHEDULES_START = 'GET_SCHEDULES_START';
export const GET_SCHEDULES_SUCCESS = 'GET_SCHEDULES_SUCCESS';
export const GET_SCHEDULES_FAIL = 'GET_SCHEDULES_FAIL';

export const GET_DENTAL_SCHEDULES_START = 'GET_DENTAL_SCHEDULES_START';
export const GET_DENTAL_SCHEDULES_SUCCESS = 'GET_DENTAL_SCHEDULES_SUCCESS';
export const GET_DENTAL_SCHEDULES_FAIL = 'GET_DENTAL_SCHEDULES_FAIL';

export const GET_PROCEDURE_CODES_START = 'GET_PROCEDURE_CODES_START';
export const GET_PROCEDURE_CODES_SUCCESS = 'GET_PROCEDURE_CODES_SUCCESS';
export const GET_PROCEDURE_CODES_FAIL = 'GET_PROCEDURE_CODES_FAIL';

export const GET_SERVICE_TYPE_DETAILS_START = 'GET_SERVICE_TYPE_DETAILS_START';
export const GET_SERVICE_TYPE_DETAILS_SUCCESS = 'GET_SERVICE_TYPE_DETAILS_SUCCESS';
export const GET_SERVICE_TYPE_DETAILS_FAIL = 'GET_SERVICE_TYPE_DETAILS_FAIL';

export const STORE_SERVICE_TYPES = 'STORE_SERVICE_TYPES';

export const ADD_SERVICE_TYPES_START = 'ADD_SERVICE_TYPES_START';
export const ADD_SERVICE_TYPES_SUCCESS = 'ADD_SERVICE_TYPES_SUCCESS';
export const ADD_SERVICE_TYPES_FAIL = 'ADD_SERVICE_TYPES_FAIL';

export const EDIT_SERVICE_TYPES_START = 'EDIT_SERVICE_TYPES_START';
export const EDIT_SERVICE_TYPES_SUCCESS = 'EDIT_SERVICE_TYPES_SUCCESS';
export const EDIT_SERVICE_TYPES_FAIL = 'EDIT_SERVICE_TYPES_FAIL';

export const DELETE_SERVICE_TYPES_START = 'DELETE_SERVICE_TYPES_START';
export const DELETE_SERVICE_TYPES_SUCCESS = 'DELETE_SERVICE_TYPES_SUCCESS';
export const DELETE_SERVICE_TYPES_FAIL = 'DELETE_SERVICE_TYPES_FAIL';

export const SYNC_BUSINESS_START = 'SYNC_BUSINESS_START';
export const SYNC_BUSINESS_SUCCESS = 'SYNC_BUSINESS_SUCCESS';
export const SYNC_BUSINESS_FAIL = 'SYNC_BUSINESS_FAIL';

export const UPDATE_SERVICE_MAPPING_START = 'UPDATE_SERVICE_MAPPING_START';
export const UPDATE_SERVICE_MAPPING_SUCCESS = 'UPDATE_SERVICE_MAPPING_SUCCESS';
export const UPDATE_SERVICE_MAPPING_FAIL = 'UPDATE_SERVICE_MAPPING_FAIL';

export const CLEAR_SERVICE_TYPES_FLAG = 'CLEAR_SERVICE_TYPES_FLAG';

export const GET_SCHEDULE_DEFINITION_START = 'GET_SCHEDULE_DEFINITION_START';
export const GET_SCHEDULE_DEFINITION_SUCCESS = 'GET_SCHEDULE_DEFINITION_SUCCESS';
export const GET_SCHEDULE_DEFINITION_FAIL = 'GET_SCHEDULE_DEFINITION_FAIL';

export const ADD_DEFINITION_START = 'ADD_DEFINITION_START';
export const ADD_DEFINITION_SUCCESS = 'ADD_DEFINITION_SUCCESS';
export const ADD_DEFINITION_FAIL = 'ADD_DEFINITION_FAIL';

export const DELETE_DEFINITION_START = 'DELETE_DEFINITION_START';
export const DELETE_DEFINITION_SUCCESS = 'DELETE_DEFINITION_SUCCESS';
export const DELETE_DEFINITION_FAIL = 'DELETE_DEFINITION_FAIL';

export const GET_BLOCK_RULES_START = 'GET_BLOCK_RULES_START';
export const GET_BLOCK_RULES_SUCCESS = 'GET_BLOCK_RULES_SUCCESS';
export const GET_BLOCK_RULES_FAIL = 'GET_BLOCK_RULES_FAIL';

export const ADD_BLOCK_RULES_START = 'ADD_BLOCK_RULES_START';
export const ADD_BLOCK_RULES_SUCCESS = 'ADD_BLOCK_RULES_SUCCESS';
export const ADD_BLOCK_RULES_FAIL = 'ADD_BLOCK_RULES_FAIL';

export const UPDATE_BLOCK_RULES_START = 'UPDATE_BLOCK_RULES_START';
export const UPDATE_BLOCK_RULES_SUCCESS = 'UPDATE_BLOCK_RULES_SUCCESS';
export const UPDATE_BLOCK_RULES_FAIL = 'UPDATE_BLOCK_RULES_FAIL';

export const DELETE_BLOCK_RULES_START = 'DELETE_BLOCK_RULES_START';
export const DELETE_BLOCK_RULES_SUCCESS = 'DELETE_BLOCK_RULES_SUCCESS';
export const DELETE_BLOCK_RULES_FAIL = 'DELETE_BLOCK_RULES_FAIL';

// Help
export const GET_HELP_START = 'GET_HELP_START';
export const GET_HELP_SUCCESS = 'GET_HELP_SUCCESS';
export const GET_HELP_FAIL = 'GET_HELP_FAIL';

// Conversations
export const GET_CONVERSATION_START = 'GET_CONVERSATION_START';
export const GET_CONVERSATION_SUCCESS = 'GET_CONVERSATION_SUCCESS';
export const GET_CONVERSATION_FAIL = 'GET_CONVERSATION_FAIL';
export const GET_CONVERSATION_DETAILS_START = 'GET_CONVERSATION_DETAILS_START';
export const GET_CONVERSATION_DETAILS_SUCCESS = 'GET_CONVERSATION_DETAILS_SUCCESS';
export const GET_CONVERSATION_DETAILS_FAIL = 'GET_CONVERSATION_DETAILS_FAIL';
export const SET_STATUS_START = 'SET_STATUS_START';
export const SET_STATUS_SUCCESS = 'SET_STATUS_SUCCESS';
export const SET_STATUS_FAIL = 'SET_STATUS_FAIL';
export const SET_CALLER_NAME_START = 'SET_CALLER_NAME_START';
export const SET_CALLER_NAME_SUCCESS = 'SET_CALLER_NAME_SUCCESS';
export const SET_CALLER_NAME_FAIL = 'SET_CALLER_NAME_FAIL';
export const MARK_RESOLVE_CLEAR = 'MARK_RESOLVE_CLEAR';
export const GET_CLIENT_INFO_START = 'GET_CLIENT_INFO_START';
export const GET_CLIENT_INFO_SUCCESS = 'GET_CLIENT_INFO_SUCCESS';
export const GET_CLIENT_INFO_FAIL = 'GET_CLIENT_INFO_FAIL';
export const POST_CONVERSATION_SEARCH_START = 'POST_CONVERSATION_SEARCH_START';
export const POST_CONVERSATION_SEARCH_SUCCESSS = 'POST_CONVERSATION_SEARCH_SUCCESSS';
export const POST_CONVERSATION_SEARCH_FAIL = 'POST_CONVERSATION_SEARCH_FAIL';
export const GET_CLIENT_APPOINTMENTS_START = 'GET_CLIENT_APPOINTMENTS_START';
export const GET_CLIENT_APPOINTMENTS_SUCCESS = 'GET_CLIENT_APPOINTMENTS_SUCCESS';
export const GET_CONVERSATION_DATA_SUCCESS = 'GET_CONVERSATION_DATA_SUCCESS';
export const GET_CLIENT_APPOINTMENTS_FAIL = 'GET_CLIENT_APPOINTMENTS_FAIL';
export const LOAD_MORE_CONVERSATION_START = 'LOAD_MORE_CONVERSATION_START';
export const LOAD_MORE_CONVERSATION_SUCCESS = 'LOAD_MORE_CONVERSATION_SUCCESS';
export const LOAD_MORE_CONVERSATION_FAIL = 'LOAD_MORE_CONVERSATION_FAIL';
export const GET_CLIENT_NOTES_START = 'GET_CLIENT_NOTES_START';
export const GET_CLIENT_NOTES_SUCCESS = 'GET_CLIENT_NOTES_SUCCESS';
export const GET_CLIENT_NOTES_FAIL = 'GET_CLIENT_NOTES_FAIL';
export const POST_CLIENT_NOTES_SUCCESS = 'POST_CLIENT_NOTES_SUCCESS';
export const POST_CLIENT_NOTES_START = 'POST_CLIENT_NOTES_START';
export const POST_CLIENT_NOTES_FAIL = 'POST_CLIENT_NOTES_FAIL';
export const GET_CONVERSATION_SUMMARY_START = 'GET_CONVERSATION_SUMMARY_START';
export const GET_CONVERSATION_SUMMARY_SUCCESS = 'GET_CONVERSATION_SUMMARY_SUCCESS';
export const GET_CONVERSATION_SUMMARY_FAIL = 'GET_CONVERSATION_SUMMARY_FAIL';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const GET_CLIENT_DETAILS_START = 'GET_CLIENT_DETAILS_START';
export const GET_CLIENT_DETAILS_SUCCESS = 'GET_CLIENT_DETAILS_SUCCESS';
export const GET_CLIENT_DETAILS_FAIL = 'GET_CLIENT_DETAILS_FAIL';
export const GET_CONVERSATION_TRANSCRIPTS_START = 'GET_CONVERSATION_TRANSCRIPTS_START';
export const GET_CONVERSATION_TRANSCRIPTS_SUCCESS = 'GET_CONVERSATION_TRANSCRIPTS_SUCCESS';
export const GET_CONVERSATION_TRANSCRIPTS_FAIL = 'GET_CONVERSATION_TRANSCRIPTS_FAIL';
export const GET_OPT_OUT_NUMBERS_START = 'GET_OPT_OUT_NUMBERS_START';
export const GET_OPT_OUT_NUMBERS_SUCCESS = 'GET_OPT_OUT_NUMBERS_SUCCESS';
export const GET_OPT_OUT_NUMBERS_FAIL = 'GET_OPT_OUT_NUMBERS_FAIL';
export const GET_OPT_OUT_REPORT_START = 'GET_OPT_OUT_REPORT_START';
export const GET_OPT_OUT_REPORT_SUCCESS = 'GET_OPT_OUT_REPORT_SUCCESS';
export const GET_OPT_OUT_REPORT_FAIL = 'GET_OPT_OUT_REPORT_FAIL';
export const CREATE_CONVERSATION = 'CREATE_CONVERSATION';
export const REMOVE_CONVERSATION = 'REMOVE_CONVERSATION';
export const MINIMIZE_SIDEBAR = 'MINIMIZE_SIDEBAR';
export const CREATE_CONVERSATION_START = 'CREATE_CONVERSATION_START';
export const CREATE_CONVERSATION_SUCCESS = 'CREATE_CONVERSATION_SUCCESS';
export const CREATE_CONVERSATION_FAIL = 'CREATE_CONVERSATION_FAIL';

export const GET_CONVERSATION_MESSAGE = 'GET_CONVERSATION_MESSAGE';
export const CONVERSATION_LOCATION_CHANGE = 'CONVERSATION_LOCATION_CHANGE';

export const GET_ASSIGNED_CONVERSATIONS_START = 'GET_ASSIGNED_CONVERSATIONS_START';
export const GET_ASSIGNED_CONVERSATIONS_SUCCESS = 'GET_ASSIGNED_CONVERSATIONS_SUCCESS';
export const GET_ASSIGNED_CONVERSATIONS_FAIL = 'GET_ASSIGNED_CONVERSATIONS_FAIL';

export const POST_ASSIGN_CONVERSATIONS_START = 'POST_ASSIGN_CONVERSATIONS_START';
export const POST_ASSIGN_CONVERSATIONS_SUCCESS = 'POST_ASSIGN_CONVERSATIONS_SUCCESS';
export const POST_ASSIGN_CONVERSATIONS_FAIL = 'POST_ASSIGN_CONVERSATIONS_FAIL';

export const POST_AUTO_RESPONSE_START = 'POST_AUTO_RESPONSE_START';
export const POST_AUTO_RESPONSE_SUCCESS = 'POST_AUTO_RESPONSE_SUCCESS';
export const POST_AUTO_RESPONSE_FAIL = 'POST_AUTO_RESPONSE_FAIL';

export const POST_MESSAGE_START = 'POST_MESSAGE_START';
export const POST_MESSAGE_SUCCESS = 'POST_MESSAGE_SUCCESS';
export const POST_MESSAGE_FAIL = 'POST_MESSAGE_FAIL';

export const ATTENTION_COUNT = 'ATTENTION_COUNT';

export const SEARCH_CONTACT_START = 'SEARCH_CONTACT_START';
export const SEARCH_CONTACT_SUCCESS = 'SEARCH_CONTACT_SUCCESS';
export const SEARCH_CONTACT_FAIL = 'SEARCH_CONTACT_FAIL';

export const GET_CONVERSATION_METRICS_START = 'GET_CONVERSATION_METRICS_START';
export const GET_CONVERSATION_METRICS_SUCCESS = 'GET_CONVERSATION_METRICS_SUCCESS';
export const GET_CONVERSATION_METRICS_FAIL = 'GET_CONVERSATION_METRICS_FAIL';

export const CLEAR_NEWLY_CREATED_SELECTION = 'CLEAR_NEWLY_CREATED_SELECTION';
export const CLEAR_JUMP_SELECTION = 'CLEAR_JUMP_SELECTION';

export const SELECT_CONTACT_FOR_SESSION = 'SELECT_CONTACT_FOR_SESSION';

export const CREATE_CONTACT_START = 'CREATE_CONTACT_START';
export const CREATE_CONTACT_SUCCESS = 'CREATE_CONTACT_SUCCESS';
export const CREATE_CONTACT_FAIL = 'CREATE_CONTACT_FAIL';

export const CLEAR_CONTACT_FLAG = 'CLEAR_CONTACT_FLAG';
export const CLEAR_NOTIFICATION_MESSAGE = 'CLEAR_NOTIFICATION_MESSAGE';

// Notifications
export const CONVERSATION_READ = 'CONVERSATION_READ';

export const POST_ERROR_REPORT_START = 'POST_ERROR_REPORT_START';
export const POST_ERROR_REPORT_SUCCESS = 'POST_ERROR_REPORT_SUCCESS';
export const POST_ERROR_REPORT_FAIL = 'POST_ERROR_REPORT_FAIL';
export const POST_ERROR_REPORT_CLEAR = 'POST_ERROR_REPORT_CLEAR';

export const UNBLOCK_NUMBER_START = 'UNBLOCK_NUMBER_START';
export const UNBLOCK_NUMBER_SUCCESS = 'UNBLOCK_NUMBER_SUCCESS';
export const UNBLOCK_NUMBER_FAIL = 'UNBLOCK_NUMBER_FAIL';
export const UNBLOCK_NUMBER_CLEAR = 'UNBLOCK_NUMBER_CLEAR';

// Outreach

export const GET_OUTREACHES_START = 'GET_OUTREACHES_START';
export const GET_OUTREACHES_SUCCESS = 'GET_OUTREACHES_SUCCESS';
export const GET_OUTREACHES_FAIL = 'GET_OUTREACHES_FAIL';

export const SAVE_OUTREACH_NAME = 'SAVE_OUTREACH_NAME';

export const CREATE_CAMPAIGN_START = 'CREATE_CAMPAIGN_START';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';
export const CREATE_CAMPAIGN_FAIL = 'CREATE_CAMPAIGN_FAIL';

export const GET_CAMPAIGN_START = 'GET_CAMPAIGN_START';
export const GET_CAMPAIGN_SUCCESS = 'GET_CAMPAIGN_SUCCESS';
export const GET_CAMPAIGN_FAIL = 'GET_CAMPAIGN_FAIL';

export const POST_CONTACTS_START = 'POST_CONTACTS_START';
export const POST_CONTACTS_SUCCESS = 'POST_CONTACTS_SUCCESS';
export const POST_CONTACTS_FAIL = 'POST_CONTACTS_FAIL';

export const DEL_CONTACTS_START = 'DEL_CONTACTS_START';
export const DEL_CONTACTS_SUCCESS = 'DEL_CONTACTS_SUCCESS';
export const DEL_CONTACTS_FAIL = 'DEL_CONTACTS_FAIL';

export const SEND_CAMPAIGN_START = 'SEND_CAMPAIGN_START';
export const SEND_CAMPAIGN_SUCCESS = 'SEND_CAMPAIGN_SUCCESS';
export const SEND_CAMPAIGN_FAIL = 'SEND_CAMPAIGN_FAIL';

export const DEL_CAMPAIGN_START = 'DEL_CAMPAIGN_START';
export const DEL_CAMPAIGN_SUCCESS = 'DEL_CAMPAIGN_SUCCESS';
export const DEL_CAMPAIGN_FAIL = 'DEL_CAMPAIGN_FAIL';

export const DOWNLOAD_REPORT_START = 'DOWNLOAD_REPORT_START';
export const DOWNLOAD_REPORT_SUCCESS = 'DOWNLOAD_REPORT_SUCCESS';
export const DOWNLOAD_REPORT_FAIL = 'DOWNLOAD_REPORT_FAIL';

export const FILE_MODAL_CLOSE = 'FILE_MODAL_CLOSE';

export const REFRESH_CAMPAIGN = 'REFRESH_CAMPAIGN';

// form response

export const GET_FORMRESPONSE_START = 'GET_FORMRESPONSE_START';
export const GET_FORMRESPONSE_SUCCESS = 'GET_FORMRESPONSE_SUCCESS';
export const GET_FORMRESPONSE_FAIL = 'GET_FORMRESPONSE_FAIL';

export const GET_FORMLIST_SUCCESS = 'GET_FORMLIST_SUCCESS';
export const GET_CAMPAIGN_LIST_SUCCESS = 'GET_CAMPAIGN_LIST_SUCCESS';

export const GET_CAMPAIGNDATA_START = 'GET_CAMPAIGNDATA_START';
export const GET_CAMPAIGNDATA_FAIL = 'GET_CAMPAIGNDATA_FAIL';
export const GET_CAMPAIGNDATA_SUCCESS = 'GET_CAMPAIGNDATA_SUCCESS';

export const GET_LETRENDS_START = 'GET_LETRENDS_START';
export const GET_LETRENDS_FAIL = 'GET_LETRENDS_FAIL';
export const GET_LETRENDS_SUCCESS = 'GET_LETRENDS_SUCCESS';

export const GET_NOTIFICATIONWEBHOOKS_START = 'GET_NOTIFICATIONWEBHOOKS_START';
export const GET_NOTIFICATIONWEBHOOKS_FAIL = 'GET_NOTIFICATIONWEBHOOKS_FAIL';
export const GET_NOTIFICATIONWEBHOOKS_SUCCESS = 'GET_NOTIFICATIONWEBHOOKS_SUCCESS';

export const UPDATE_NOTIFICATIONWEBHOOKS_START = 'UPDATE_NOTIFICATIONWEBHOOKS_START';
export const UPDATE_NOTIFICATIONWEBHOOKS_FAIL = 'UPDATE_NOTIFICATIONWEBHOOKS_FAIL';
export const UPDATE_NOTIFICATIONWEBHOOKS_SUCCESS = 'UPDATE_NOTIFICATIONWEBHOOKS_SUCCESS';

export const DELETE_NOTIFICATIONWEBHOOKS_START = 'DELETE_NOTIFICATIONWEBHOOKS_START';
export const DELETE_NOTIFICATIONWEBHOOKS_FAIL = 'DELETE_NOTIFICATIONWEBHOOKS_FAIL';
export const DELETE_NOTIFICATIONWEBHOOKS_SUCCESS = 'DELETE_NOTIFICATIONWEBHOOKS_SUCCESS';

export const GET_FORMSERVICES_START = 'GET_FORMSERVICES_START';
export const GET_FORMSERVICES_SUCCESS = 'GET_FORMSERVICES_SUCCESS';
export const GET_FORMSERVICES_FAIL = 'GET_FORMSERVICES_FAIL';

export const SET_CAMPAIGNTYPE_SUCCESS = 'SET_CAMPAIGNTYPE_SUCCESS';

export const POST_FORM_START = 'POST_FORM_START';
export const POST_FORM_SUCCESS = 'POST_FORM_SUCCESS';
export const POST_FORM_FAIL = 'POST_FORM_FAIL';

export const EDIT_FORM_SUCCESS = 'EDIT_FORM_SUCCESS';

export const POST_DETAILS_START = 'POST_DETAILS_START';
export const POST_DETAILS_SUCCESS = 'POST_DETAILS_SUCCESS';
export const POST_DETAILS_FAIL = 'POST_DETAILS_FAIL';

export const DELETE_FORM_SUCCESS = 'DELETE_FORM_SUCCESS';

export const FORM_CLEAR_FLAGS = 'FORM_CLEAR_FLAGS';
export const GET_BLOCKED_NUMBERS_START = 'GET_BLOCKED_NUMBERS_START';
export const GET_BLOCKED_NUMBERS_SUCCESS = 'GET_BLOCKED_NUMBERS_SUCCESS';
export const GET_BLOCKED_NUMBERS_FAIL = 'GET_BLOCKED_NUMBERS_FAIL';

export const CLEAR_BLOCK_DATA = 'CLEAR_BLOCK_DATA';

export const SAVE_LEAD_NAME = 'SAVE_LEAD_NAME';

export const GET_LEAD_REPORT_START = 'GET_LEAD_REPORT_START';
export const GET_LEAD_REPORT_SUCCESS = 'GET_LEAD_REPORT_SUCCESS';
export const GET_LEAD_REPORT_FAIL = 'GET_LEAD_REPORT_FAIL';

// Webchat preference
export const GET_WEBCHAT_PREFERENCE_START = 'GET_WEBCHAT_PREFERENCE_START';
export const GET_WEBCHAT_PREFERENCE_SUCCESS = 'GET_WEBCHAT_PREFERENCE_SUCCESS';
export const GET_WEBCHAT_PREFERENCE_FAIL = 'GET_WEBCHAT_PREFERENCE_FAIL';

export const GET_GROUP_INTENT_START = 'GET_GROUP_INTENT_START';
export const GET_GROUP_INTENT_SUCCESS = 'GET_GROUP_INTENT_SUCCESS';
export const GET_GROUP_INTENT_FAIL = 'GET_GROUP_INTENT_FAIL';

export const POST_WEBCHAT_STATUS_START = 'POST_WEBCHAT_STATUS_START';
export const POST_WEBCHAT_STATUS_SUCCESS = 'POST_WEBCHAT_STATUS_SUCCESS';
export const POST_WEBCHAT_STATUS_FAIL = 'POST_WEBCHAT_STATUS_FAIL';

export const POST_WEBCHAT_GREETING_START = 'POST_WEBCHAT_GREETING_START';
export const POST_WEBCHAT_GREETING_SUCCESS = 'POST_WEBCHAT_GREETING_SUCCESS';
export const POST_WEBCHAT_GREETING_FAIL = 'POST_WEBCHAT_GREETING_FAIL';

export const POST_WEBCHAT_BRAND_SUCCESS = 'POST_WEBCHAT_BRAND_SUCCESS';
export const POST_WEBCHAT_EMAILPREF_SUCCESS = 'POST_WEBCHAT_EMAILPREF_SUCCESS';
export const POST_WEBCHAT_COLLAPSE_SUCCESS = 'POST_WEBCHAT_COLLAPSE_SUCCESS';
export const POST_WEBCHAT_EMAIL_SUCCESS = 'POST_WEBCHAT_EMAIL_SUCCESS';

export const POST_WEBCHAT_EMAIL_START = 'POST_WEBCHAT_EMAIL_START';
export const POST_WEBCHAT_EMAIL_FAIL = 'POST_WEBCHAT_EMAILPREF_FAIL';

export const POST_WEBCHAT_LOGO_START = 'POST_WEBCHAT_LOGO_START';
export const POST_WEBCHAT_LOGO_SUCCESS = 'POST_WEBCHAT_LOGO_SUCCESS';
export const POST_WEBCHAT_LOGO_FAIL = 'POST_WEBCHAT_LOGO_FAIL';

export const POST_WEBCHAT_LOGO_SIZE_ISSUE = 'POST_WEBCHAT_LOGO_SIZE_ISSUE';

// Staff Management
export const ADD_STAFF_START = 'ADD_STAFF_START';
export const ADD_STAFF_SUCCESS = 'ADD_STAFF_SUCCESS';
export const ADD_STAFF_FAIL = 'ADD_STAFF_FAIL';

export const DELETE_STAFF_START = 'DELETE_STAFF_START';
export const DELETE_STAFF_SUCCESS = 'DELETE_STAFF_SUCCESS';
export const DELETE_STAFF_FAIL = 'DELETE_STAFF_FAIL';

export const UPDATE_STAFF_PASSWORD_START = 'UPDATE_STAFF_PASSWORD_START';
export const UPDATE_STAFF_PASSWORD_SUCCESS = 'UPDATE_STAFF_PASSWORD_SUCCESS';
export const UPDATE_STAFF_PASSWORD_FAIL = 'UPDATE_STAFF_PASSWORD_FAIL';

export const UPDATE_STAFF_INFO_START = 'UPDATE_STAFF_INFO_START';
export const UPDATE_STAFF_INFO_SUCCESS = 'UPDATE_STAFF_INFO_SUCCESS';
export const UPDATE_STAFF_INFO_FAIL = 'UPDATE_STAFF_INFO_FAIL';

export const GET_STAFF_LIST_START = 'GET_STAFF_LIST_START';
export const GET_STAFF_LIST_SUCCESS = 'GET_STAFF_LIST_SUCCESS';
export const GET_STAFF_LIST_FAIL = 'GET_STAFF_LIST_FAIL';

// Webbooking preference

export const GET_WEBBOOKING_PREFERENCE_START = 'GET_WEBBOOKING_PREFERENCE_START';
export const GET_WEBBOOKING_PREFERENCE_SUCCESS = 'GET_WEBBOOKING_PREFERENCE_SUCCESS';
export const GET_WEBBOOKING_PREFERENCE_FAIL = 'GET_WEBBOOKING_PREFERENCE_FAIL';

export const POST_WEBBOOKING_START = 'POST_WEBBOOKING_START';
export const POST_WEBBOOKING_SUCCESS = 'POST_WEBBOOKING_SUCCESS';
export const POST_WEBBOOKING_FAIL = 'POST_WEBBOOKING_FAIL';

export const POST_WEBBOOKING_STATUS_START = 'POST_WEBBOOKING_STATUS_START';
export const POST_WEBBOOKING_STATUS_SUCCESS = 'POST_WEBBOOKING_STATUS_SUCCESS';
export const POST_WEBBOOKING_STATUS_FAIL = 'POST_WEBBOOKING_STATUS_FAIL';

export const POST_WEBBOOKING_INSTRUCTION_START = 'POST_WEBBOOKING_INSTRUCTION_START';
export const POST_WEBBOOKING_INSTRUCTION_SUCCESS = 'POST_WEBBOOKING_INSTRUCTION_SUCCESS';
export const POST_WEBBOOKING_INSTRUCTION_FAIL = 'POST_WEBBOOKING_INSTRUCTION_FAIL';

export const GET_WEBBOOKING_WORKFLOW_START = 'GET_WEBBOOKING_WORKFLOW_START';
export const GET_WEBBOOKING_WORKFLOW_SUCCESS = 'GET_WEBBOOKING_WORKFLOW_SUCCESS';
export const GET_WEBBOOKING_WORKFLOW_FAIL = 'GET_WEBBOOKING_WORKFLOW_FAIL';

export const POST_WEBBOOKING_WORKFLOW_START = 'POST_WEBBOOKING_WORKFLOW_START';
export const POST_WEBBOOKING_WORKFLOW_SUCCESS = 'POST_WEBBOOKING_WORKFLOW_SUCCESS';
export const POST_WEBBOOKING_WORKFLOW_FAIL = 'POST_WEBBOOKING_WORKFLOW_FAIL';

// Appointment Reminder
export const GET_APPOINTMENT_REMINDERS_START = 'GET_APPOINTMENT_REMINDERS_START';
export const GET_APPOINTMENT_REMINDERS_SUCCESS = 'GET_APPOINTMENT_REMINDERS_SUCCESS';
export const GET_APPOINTMENT_REMINDERS_FAIL = 'GET_APPOINTMENT_REMINDERS_FAIL';

export const ADD_APPOINTMENT_REMINDERS_START = 'ADD_APPOINTMENT_REMINDERS_START';
export const ADD_APPOINTMENT_REMINDERS_SUCCESS = 'ADD_APPOINTMENT_REMINDERS_SUCCESS';
export const ADD_APPOINTMENT_REMINDERS_FAIL = 'ADD_APPOINTMENT_REMINDERS_FAIL';

export const DELETE_APPOINTMENT_REMINDERS_START = 'DELETE_APPOINTMENT_REMINDERS_START';
export const DELETE_APPOINTMENT_REMINDERS_SUCCESS = 'DELETE_APPOINTMENT_REMINDERS_SUCCESS';
export const DELETE_APPOINTMENT_REMINDERS_FAIL = 'DELETE_APPOINTMENT_REMINDERS_FAIL';

export const GET_CONVERSATIONS_REMINDERS_START = 'GET_CONVERSATIONS_REMINDERS_START';
export const GET_CONVERSATIONS_REMINDERS_SUCCESS = 'GET_CONVERSATIONS_REMINDERS_SUCCESS';
export const GET_CONVERSATIONS_REMINDERS_FAIL = 'GET_CONVERSATIONS_REMINDERS_FAIL';

export const GET_REMINDER_STATS_START = 'GET_REMINDER_STATS_START';
export const GET_REMINDER_STATS_SUCCESS = 'GET_REMINDER_STATS_SUCCESS';
export const GET_REMINDER_STATS_FAIL = 'GET_REMINDER_STATS_FAIL';

export const DOWNLOAD_REMINDER_START = 'DOWNLOAD_REMINDER_START';
export const DOWNLOAD_REMINDER_SUCCESS = 'DOWNLOAD_REMINDER_SUCCESS';
export const DOWNLOAD_REMINDER_FAIL = 'DOWNLOAD_REMINDER_FAIL';

export const UPDATE_REMINDER_STATUS_START = 'UPDATE_REMINDER_STATUS_START';
export const UPDATE_REMINDER_STATUS_SUCCESS = 'UPDATE_REMINDER_STATUS_SUCCESS';
export const UPDATE_REMINDER_STATUS_FAIL = 'UPDATE_REMINDER_STATUS_FAIL';

// Staff mapping
export const UPDATE_STAFF_MAPPING_START = 'UPDATE_STAFF_MAPPING_START';
export const UPDATE_STAFF_MAPPING_SUCCESS = 'UPDATE_STAFF_MAPPING_SUCCESS';
export const UPDATE_STAFF_MAPPING_FAIL = 'UPDATE_STAFF_MAPPING_FAIL';

export const GET_STAFF_MAPPING_START = 'GET_STAFF_MAPPING_START';
export const GET_STAFF_MAPPING_SUCCESS = 'GET_STAFF_MAPPING_SUCCESS';
export const GET_STAFF_MAPPING_FAIL = 'GET_STAFF_MAPPING_FAIL';

export const DELETE_STAFF_MAPPING_START = 'DELETE_STAFF_MAPPING_START';
export const DELETE_STAFF_MAPPING_SUCCESS = 'DELETE_STAFF_MAPPING_SUCCESS';
export const DELETE_STAFF_MAPPING_FAIL = 'DELETE_STAFF_MAPPING_FAIL';

// Analytics Report
export const GET_ALLOWED_ANALYTICS_REPORT_START = 'GET_ALLOWED_ANALYTICS_REPORT_START';
export const GET_ALLOWED_ANALYTICS_REPORT_SUCCESS = 'GET_ALLOWED_ANALYTICS_REPORT_SUCCESS';
export const GET_ALLOWED_ANALYTICS_REPORT_FAIL = 'GET_ALLOWED_ANALYTICS_REPORT_FAIL';

// AI Assists configuration
export const GET_CONFIGS_START = 'GET_CONFIGS_START';
export const GET_CONFIGS_SUCCESS = 'GET_CONFIGS_SUCCESS';
export const GET_CONFIGS_FAIL = 'GET_CONFIGS_FAIL';

export const GET_CATEGORIES_START = 'GET_CATEGORIES_START';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAIL = 'GET_CATEGORIES_FAIL';

export const ADD_CONFIG_START = 'ADD_CONFIG_START';
export const ADD_CONFIG_SUCCESS = 'ADD_CONFIG_SUCCESS';
export const ADD_CONFIG_FAIL = 'ADD_CONFIG_FAIL';

export const BULK_ADD_START = 'BULK_ADD_START';
export const BULK_ADD_PROGRESS = 'BULK_ADD_PROGRESS';
export const BULK_ADD_SUCCESS = 'BULK_ADD_SUCCESS';
export const BULK_ADD_FAIL = 'BULK_ADD_FAIL';

export const UPDATE_CONFIG_START = 'UPDATE_CONFIG_START';
export const UPDATE_CONFIG_SUCCESS = 'UPDATE_CONFIG_SUCCESS';
export const UPDATE_CONFIG_FAIL = 'UPDATE_CONFIG_FAIL';

export const DELETE_CONFIG_START = 'DELETE_CONFIG_START';
export const DELETE_CONFIG_SUCCESS = 'DELETE_CONFIG_SUCCESS';
export const DELETE_CONFIG_FAIL = 'DELETE_CONFIG_FAIL';

export const BULK_DELETE_START = 'BULK_DELETE_START';
export const BULK_DELETE_SUCCESS = 'BULK_DELETE_SUCCESS';
export const BULK_DELETE_FAIL = 'BULK_DELETE_FAIL';

export const SEARCH_CONFIGS_START = 'SEARCH_CONFIGS_START';
export const SEARCH_CONFIGS_SUCCESS = 'SEARCH_CONFIGS_SUCCESS';
export const SEARCH_CONFIGS_FAIL = 'SEARCH_CONFIGS_FAIL';
export const CLEAR_CONFIGS_SEARCH = 'CLEAR_CONFIGS_SEARCH';

export const SELECT_CONFIG = 'SELECT_CONFIG';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const RESET_STATE = 'RESET_STATE';
export const SET_LOADING = 'SET_LOADING';

// Service Agent
export const GET_SERVICE_AGENT_START = 'GET_SERVICE_AGENT_START';
export const GET_SERVICE_AGENT_SUCCESS = 'GET_SERVICE_AGENT_SUCCESS';
export const GET_SERVICE_AGENT_FAIL = 'GET_SERVICE_AGENT_FAIL';

export const UPDATE_BUSINESS_NAME_START = 'UPDATE_BUSINESS_NAME_START';
export const UPDATE_BUSINESS_NAME_SUCCESS = 'UPDATE_BUSINESS_NAME_SUCCESS';
export const UPDATE_BUSINESS_NAME_FAIL = 'UPDATE_BUSINESS_NAME_FAIL';

export const GET_NEW_PHONE_NUMBER_START = 'GET_NEW_PHONE_NUMBER_START';
export const GET_NEW_PHONE_NUMBER_SUCCESS = 'GET_NEW_PHONE_NUMBER_SUCCESS';
export const GET_NEW_PHONE_NUMBER_FAIL = 'GET_NEW_PHONE_NUMBER_FAIL';
export const GET_NEW_PHONE_NUMBER_CLEAR = 'GET_NEW_PHONE_NUMBER_CLEAR';

export const GET_CUSTOM_TAGS_START = 'GET_CUSTOM_TAGS_START';
export const GET_CUSTOM_TAGS_SUCCESS = 'GET_CUSTOM_TAGS_SUCCESS';
export const GET_CUSTOM_TAGS_FAIL = 'GET_CUSTOM_TAGS_FAIL';

export const ADD_CUSTOM_TAGS_START = 'ADD_CUSTOM_TAGS_START';
export const ADD_CUSTOM_TAGS_SUCCESS = 'ADD_CUSTOM_TAGS_SUCCESS';
export const ADD_CUSTOM_TAGS_FAIL = 'ADD_CUSTOM_TAGS_FAIL';

export const DELETE_CUSTOM_TAG_START = 'DELETE_CUSTOM_TAG_START';
export const DELETE_CUSTOM_TAG_SUCCESS = 'DELETE_CUSTOM_TAG_SUCCESS';
export const DELETE_CUSTOM_TAG_FAIL = 'DELETE_CUSTOM_TAG_FAIL';

export const ADD_TAG_TO_USER_START = 'ADD_TAG_TO_USER_START';
export const ADD_TAG_TO_USER_SUCCESS = 'ADD_TAG_TO_USER_SUCCESS';
export const ADD_TAG_TO_USER_FAIL = 'ADD_TAG_TO_USER_FAIL';

export const REMOVE_TAGOF_USER_START = 'REMOVE_TAGOF_USER_START';
export const REMOVE_TAGOF_USER_SUCCESS = 'REMOVE_TAGOF_USER_SUCCESS';
export const REMOVE_TAGOF_USER_FAIL = 'REMOVE_TAGOF_USER_FAIL';
export const GET_VOICE_STATUS_START = 'GET_VOICE_STATUS_START';
export const GET_VOICE_STATUS_SUCCESS = 'GET_VOICE_STATUS_SUCCESS';
export const GET_VOICE_STATUS_FAIL = 'GET_VOICE_STATUS_FAIL';

export const UPDATE_VOICE_STATUS_START = 'UPDATE_VOICE_STATUS_START';
export const UPDATE_VOICE_STATUS_SUCCESS = 'UPDATE_VOICE_STATUS_SUCCESS';
export const UPDATE_VOICE_STATUS_FAIL = 'UPDATE_VOICE_STATUS_FAIL';

export const UPDATE_WEAVE_PHONE_START = 'UPDATE_WEAVE_PHONE_START';
export const UPDATE_WEAVE_PHONE_SUCCESS = 'UPDATE_WEAVE_PHONE_SUCCESS';
export const UPDATE_WEAVE_PHONE_FAIL = 'UPDATE_WEAVE_PHONE_FAIL';
export const CLEAR_ERROR_MEESSAGE_VOICE = 'CLEAR_ERROR_MEESSAGE_VOICE';

export const MIGRATE_TO_WEAVE_START = 'MIGRATE_TO_WEAVE_START';
export const MIGRATE_TO_WEAVE_SUCCESS = 'MIGRATE_TO_WEAVE_SUCCESS';
export const MIGRATE_TO_WEAVE_FAIL = 'MIGRATE_TO_WEAVE_FAIL';

export const UPDATE_WEAVE_INFO_START = 'UPDATE_WEAVE_INFO_START';
export const UPDATE_WEAVE_INFO_SUCCESS = 'UPDATE_WEAVE_INFO_SUCCESS';
export const UPDATE_WEAVE_INFO_FAIL = 'UPDATE_WEAVE_INFO_FAIL';

export const CAN_MIGRATE_TO_WEAVE_START = 'CAN_MIGRATE_TO_WEAVE_START';
export const CAN_MIGRATE_TO_WEAVE_SUCCESS = 'CAN_MIGRATE_TO_WEAVE_SUCCESS';
export const CAN_MIGRATE_TO_WEAVE_FAIL = 'CAN_MIGRATE_TO_WEAVE_FAIL';

export const GET_OUTCOME_VISUALISATION_START = 'GET_OUTCOME_VISUALISATION_START';
export const GET_OUTCOME_VISUALISATION_SUCCESS = 'GET_OUTCOME_VISUALISATION_SUCCESS';
export const GET_OUTCOME_VISUALISATION_FAIL = 'GET_OUTCOME_VISUALISATION_FAIL';
